import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";
import AssetTypeMiddleware from "../../../../middleware/modules/accounting/asset-type";
import AssetType from "../../../../components/modules/accounting/asset-type";
// middlewares

const mapStateToProps = ({ auth, assetType }) => ({
  isProcessing: assetType.isProcessing,
  isError: assetType.isError,
  errorMessage: assetType.errorMessage,
  datalist: assetType.data,
  helperAssetType: assetType.helperAssetType,
  afterSave: assetType.afterSave,
  showModal: assetType.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      create: () => AssetTypeMiddleware.create(),
      getHelper: () => AssetTypeMiddleware.getHelper(),
      reset: () => AssetTypeMiddleware.resetList(),
      search: (data) => AssetTypeMiddleware.list(data),
      update: (data) => AssetTypeMiddleware.update(data),
      view: (data) => AssetTypeMiddleware.update(data),
      void: (data,search) => AssetTypeMiddleware.beforeVoid(data,search),
      delete: (id, search) => AssetTypeMiddleware.beforeDelete(id, search),
      submit: (data, search) => AssetTypeMiddleware.beforeSaveNew(data, search),
    },
    dispatch
  );
};
class AssetTypeContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired,
    afterSave: PropTypes.bool,

  };

  static defaultProps = {
    afterSave: false,
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.submitItem = this.submitItem.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.createItem = this.createItem.bind(this);
    this.viewItem = this.viewItem.bind(this);
    this.voidItem = this.voidItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
  }

  createItem() {
    this.props.getHelper();
    this.props.create();
  }

  updateItem(id) {
    this.props.getHelper();
    this.props.update(id);
  }

  submitItem() {
    this.props.submit();
  }

  viewItem(id) {
    this.props.view(id);
  }

  voidItem(data,search) {
    this.props.void(data,search);
  }

  render() {
    const { isProcessing, search, datalist, showModal } =
      this.props

    return (
      <React.Fragment>
        <Helmet>
          <title>{i18n.t("Asset Type List")}</title>
        </Helmet>
        <AssetType
          {...this.props}
          createData={this.createItem}
          updateItem={this.updateItem}
          voidItem={this.voidItem}
          viewItem={this.viewItem}
          showModal={showModal}
        />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetTypeContainer);
